export const getValueFromEventTarget = (event) => event.target.value;